<template>
  <div class="dashboard_left absolute">
    <div style="display: flex; flex-flow: column; height: 100%">
      <div class="contain_top">
        <!-- 公共title -->
        <Top :name="$t('Unit Information')" :show-button="false"></Top>
        <div class="top_data">
          <EquipInfo  :equip_data="equip_data"></EquipInfo>
        </div>
      </div>
      <!--<div class="contain_center">
        <Top :name="$t('Recent Events')" :show-button="false"></Top>
        <div class="top_data">
          <EquipWarning></EquipWarning>
        </div>
      </div> 公共title -->
      <div class="contain_center">
        <Top :name="$t('Recent Events')" :show-button="false"></Top>
        <div class="top_data d-flex flex-wrap align-content-around">
          <div class="mt-1 w-100" v-for="(a,i) in 3" :key="a">
            <div class="w-100 d-flex justify-content-between">
              <div class="d-flex align-items-center">
                <img
                  style="width: 15px; height: 15px"
                  class="me-2"
                  src="./icon-success.svg"
                  alt="#"
                />
                <div>{{ $t("提醒") }}</div>
              </div>
              <div v-if="$store.state.equipManagement.is_stmart_om_equipment">{{isPaperMaking?`2025-04-${11-(i*3)} 18:25:49`:`2024-10-0${ 7 - i } 18:25:49`}}</div>
              <div v-else>2024-0{{ 6 - (a - 1) }}-14 18:25:49</div>
            </div>
            <div class="ps-4 fs-14">
              {{ isPaperMaking?$t("smart_OM_model_paper_making.this_inspection_indicates_good"):$t("本次检测健康，无气蚀风险，无轴承相关风险") }}
            </div>
          </div>
        </div>
      </div>
      <div class="contain_footer">
        <!-- 公共title -->
        <div class="relative">
          <!-- :name="$t('Fault Type') + ':' + breakdown_point" -->
          <Top :name="$t('Fault Type')" :show-button="false"></Top>
          <div
            v-if="false"
            style="position: fixed; top: 48.8%; left: 370px"
            class="d-flex align-items-center"
          >
            <i
              class="ri-arrow-down-s-line"
              data-bs-toggle="dropdown"
              data-bs-auto-close="outside"
              aria-haspopup="true"
              aria-expanded="false"
            >
            </i>
            <div
              class="dropdown-menu dropdown-menu-end dropdown_box"
              aria-labelledby="dropdownMenuClickableInside"
              style="
                width: 300px;
                color: #fff;
                z-index: 1;
                padding: 10px 0px;
                border-radius: 1.25rem;
                background: linear-gradient(
                  152deg,
                  rgba(49, 46, 46, 0.4) 0%,
                  rgba(69, 68, 65, 0.4) 100%
                );
                box-shadow: 0px 1.25rem 3.8125rem 0px rgba(16, 20, 28, 0.6);
                border-top: 0.0625rem solid #b6b7bc3f;
                border-left: 0.0625rem solid #b6b7bc3f;
                border-right: 0.0625rem solid #b6b7bc3f;
                height: 350px;
              "
            >
              <div class="h-100 w-100">
                <div>
                  <p class="mb-0" style="font-size: 18px; margin-left: 20px">
                    {{ $t("Fault Type") }}
                  </p>
                  <img src="./icon-divider.svg" alt="" />
                </div>
                <div
                  id="cockpitTree"
                  data-simplebar
                  data-simplebar-auto-hide="false"
                  style="
                    overflow: auto;
                    width: 100%;
                    height: calc(100% - 60px);
                    max-height: calc(100% - 60px);
                  "
                >
                  <div>
                    <div
                      v-for="a in modelList"
                      :key="a.name"
                      class="a-item mt-1 pt-1 pb-1"
                      :style="{
                        width: '85%',
                        paddingLeft: '25px',
                        cursor: 'default',
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center',
                        background: a.iconType
                          ? 'rgba(0, 231, 255, 0.80)'
                          : 'rgba(0, 231, 255,0)',
                      }"
                    >
                      <input
                        class="form-check-input me-1 mt-0 p-0"
                        type="checkbox"
                        v-model="a.iconType"
                        @change="changeType(a)"
                      />
                      {{ a.name }}
                    </div>
                    <!--  <el-radio-group v-model="radio1" class="d-flex flex-wrap">
                      <el-radio
                        :label="$t('结垢')"
                        class="w-100 text-white ps-3"
                        size="small"
                        >{{ $t("结垢") }}</el-radio
                      >
                      <el-radio
                        :label="$t('气蚀分析')"
                        class="w-100 text-white ps-3"
                        size="small"
                        >{{ $t("气蚀分析") }}</el-radio
                      >
                      <el-radio
                        :label="$t('无法启动')"
                        class="w-100 text-white ps-3"
                        size="small"
                        >{{ $t("无法启动") }}</el-radio
                      >
                      <el-radio
                        :label="$t('轴承故障')"
                        class="w-100 text-white ps-3"
                        size="small"
                        >{{ $t("轴承故障") }}</el-radio
                      >
                      <el-radio
                        :label="$t('泄漏')"
                        class="w-100 text-white ps-3"
                        size="small"
                        >{{ $t("泄漏") }}</el-radio
                      >
                      <el-radio
                        :label="$t('真空度不足')"
                        class="w-100 text-white ps-3"
                        size="small"
                        >{{ $t("真空度不足") }}</el-radio
                      >
                      <el-radio
                        :label="$t('真空泵NDE轴承水平振动')"
                        class="w-100 text-white ps-3"
                        size="small"
                        >{{ $t("真空泵NDE轴承水平振动") }}</el-radio
                      >
                      <el-radio
                        :label="$t('真空泵NDE轴承轴向振动')"
                        class="w-100 text-white ps-3"
                        size="small"
                        >{{ $t("真空泵NDE轴承轴向振动") }}</el-radio
                      >
                    </el-radio-group>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer_data">
          <EchartsModel
            :equip_data="equip_data"
            :breakdown_point="breakdown_point"
            :measurements_list="measurements_list"
          ></EchartsModel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EquipInfo from "./component/EquipInfo";
// import EquipWarning from "./component/EquipWarning";
import EchartsModel from "./component/EchartsModel";
export default {
  props: ["equip_data","breakdown_point","measurements_list"],
  data() {
    return {
      selectPlan: {
        next: this.$t("Next Service Plan"),
        pre: "上次保养记录",
      },
      currentSelect: "next",
      radio1:this.$t("气蚀分析"),
      modelList: [
        {
          name: this.$t("结垢"),
          iconType: false,
        },
        {
          name: this.$t("气蚀分析"),
          iconType: true,
        },
        {
          name: this.$t("无法启动"),
          iconType: false,
        },
        {
          name: this.$t("轴承故障"),
          iconType: false,
        },
        {
          name: this.$t("泄漏"),
          iconType: false,
        },
        {
          name: this.$t("真空度不足"),
          iconType: false,
        },
        {
          name: this.$t("真空泵NDE轴承水平振动"),
          iconType: false,
        },
        {
          name: this.$t("真空泵NDE轴承轴向振动"),
          iconType: false,
        },
      ],
    };
  },
  methods: {
    changeType(item) {
        this.modelList.map(a=>{
            a["iconType"]=false
        })
        this.radio1 = item['name']
      item["iconType"] = !item["iconType"];
    },
  },
  computed:{
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    },
    measurementsList(){
      return this.measurements_list;
    }
  },
  components: {
    EquipInfo,
    // EquipWarning,
    EchartsModel,
  },
};
</script>

<style scoped lang="scss">
@import url("../../../../assets/scss/common.scss");

.dashboard_left {
  width: 400px;
  height: 100%;
  top: 0;
  left: 0;

  .contain_top,
  .contain_center,
  .contain_footer {
    display: flex;
    flex-flow: column;
    overflow: hidden;
    margin-bottom: 10px;
    font-size: 17px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    padding: 20px 20px 10px;
    display: flex;
    flex-flow: column;
    .top_data {
      flex: 1;
    }
  }
  .contain_top {
    height: 30%;
    flex: 1;
  }
  .contain_center {
    height: 25%;
    .top_data {
      height: 90%;
    }
  }
  .contain_footer {
    flex: 1.2;
    margin-bottom: 0;
    .footer_data {
      height: 90%;
    }
  }
}
.dropdown_box {
  left: 45px !important;
  top: -40px !important;
}
</style>
